import React, {useEffect, useRef, useState} from "react";
import Utilities from "@util/Utilities";

type Props = {
    placeholderSrc?: string,
    placeholderClassName?: string,
    placeholderStyle?: React.CSSProperties,
    src: string,
    alt: string,
    className?: string,
    title?: string,
    style?: React.CSSProperties,
    waitForImageToExist?: boolean
}

const LazyImage: React.FunctionComponent<Props> = ({
                                                       placeholderSrc = "/assets/img/placeholder-img.png",
                                                       placeholderClassName,
                                                       placeholderStyle,
                                                       src,
                                                       alt,
                                                       className,
                                                       title,
                                                       style,
                                                       waitForImageToExist = false,
                                                   }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [view, setView] = useState("");
    const loaderRef = useRef(null);
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        let interval: NodeJS.Timer | undefined = undefined;
        // Initiating Intersection Observer
        const observer = new IntersectionObserver((entries) => {
            // Set actual image source && unobserve when intersecting
            if (entries[0].isIntersecting) {
                if (waitForImageToExist) {
                    interval = checkImageExists(src);
                } else setView(src)
                observer.unobserve(loaderRef.current!);
            }
        });

        // observe for an placeholder image
        if (loaderRef && loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (!!interval) {
                // @ts-ignore
                clearInterval(interval);
            }
            if (!!loaderRef.current)
                observer.unobserve(loaderRef.current!);

        }
    }, [src]);

    const checkImageExists = (src: string) => {
        let retries = 10;

        const interval = setInterval(() => {
            const img = new Image();
            img.src = src;

            img.onload = () => {
                setView(src);
                clearInterval(interval);
            }
            img.onerror = () => {
                if (retries === 0) {
                    clearInterval(interval)
                    setHasError(true)
                }
                retries--;
            }
        }, 1000);

        return interval;


    }

    return (
        <>
            {isLoading && !hasError && (
                <svg ref={loaderRef} className="max-w-[64px] max-h-[64px] mx-auto"
                     version="1.1" id="L9"
                     x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 0 0">
                    <path fill="#64748A"
                          d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                        <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50"
                                      to="360 50 50" repeatCount="indefinite"></animateTransform>
                    </path>
                </svg>

            )}
            {hasError && <img
                src={placeholderSrc}
                alt="placeholder"
                className={placeholderClassName}
                style={placeholderStyle}/>}
            <img
                src={view} // Gets src only when placeholder intersecting
                className={Utilities.classNames(className, "transition-all duration-300")}
                title={title}
                style={isLoading ? {display: "none"} : style}
                alt={alt}
                onLoad={() => setIsLoading(false)}
            />
        </>
    );
};
export default LazyImage;